__webpack_require__.p = "/simple-daterangepicker/";